import { FC } from "react";
import styled from "styled-components";
import { GridGallerySectionProps } from "../../types";

const GridGallerySection: FC<GridGallerySectionProps> = ({
  children,
  itemsPerRow,
  isProduct,
}) => {
  return (
    <GridContainer itemsPerRow={itemsPerRow} isProduct={isProduct}>
      {children}
    </GridContainer>
  );
};

export default GridGallerySection;

const GridContainer = styled.div<{
  itemsPerRow?: number;
  isProduct?: boolean;
}>`
  display: grid;
  flex-wrap: wrap;
  grid-template-columns: repeat(${({ itemsPerRow }) => itemsPerRow}, 1fr);
  gap: ${({ isProduct }) => (isProduct ? "24px" : "16px")};

  @media (max-width: 768px) {
    grid-template-columns: repeat(
      ${({ isProduct }) => (isProduct ? 2 : 1)},
      1fr
    );
  }
`;
